import api from '../../../App/socket';

export const createBikeModelVariant = params => (
    api.send({
        api: 'db',
        model: 'Bike_variant',
        action: 'Create',
        options: {
            create: params,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_variant_create/requests/create_bike_model_variant_request.js